export const MAX_FILE_BYTES = 10 * 1024 * 1024; // ~10 MB, matches the backend cap
export const MAX_LOGO_BYTES = 1.4 * 1024 * 1024; // ~1.4 MB, backend rejects >~1.5 MB of base64

/** Reads a File and returns bare base64 (no `data:...;base64,` prefix). */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Could not read the file.'));
    reader.onload = () => {
      const result = String(reader.result);
      const comma = result.indexOf(',');
      resolve(comma === -1 ? result : result.slice(comma + 1));
    };
    reader.readAsDataURL(file);
  });
}

/** Data URL form — for image previews / logo storage. */
export function fileToDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Could not read the file.'));
    reader.onload = () => resolve(String(reader.result));
    reader.readAsDataURL(file);
  });
}
